@import "~@govbr-ds/core/src/components/wizard/mixins";

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border-width: 0;
}

:host {
  @include wizard-tokens;
  @include wizard-default;
  @include wizard-progress;
  @include wizard-progress-collapsed;
  @include wizard-vertical;
  @include wizard-form;
  @include wizard-dark-mode;

  br-step-item[active] {
    --step-label-font-weight: var(--font-weight-semi-bold);
    --step-label-color: var(--active);
  }

  br-step-item::part(label) {
    display: block;
    line-height: 1em;
    text-align: center;
  }

  .wizard-progress {
    place-content: center center;
    height: auto;
    padding-top: 0;

    @include media-breakpoint-down(sm) {
      br-step-item::part(label) {
        font-size: var(--font-size-scale-down-02, $font-size-scale-down-02);
      }
    }
  }
}

:host([collapsed]) {
  br-step-item::part(label) {
    display: none;
  }

  @include media-breakpoint-down(sm) {
    br-step-item::part(label) {
      display: none;
    }

    .wizard-progress {
      max-height: 64px;
      min-height: 64px;
      overflow-y: hidden;
      padding-bottom: var(--spacing-scale-3x);
      padding-top: var(--spacing-scale-3x);

      &::after {
        margin-top: var(--spacing-scale-4xh);
      }
    }
  }
}

:host([vertical]) {
  flex-direction: row;

  .wizard-progress {
    flex: 1;
    float: none;
    grid-template-columns: 1fr;
    height: auto;
    max-width: 260px;
    overflow-x: hidden;
    padding-top: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  @include media-breakpoint-down(sm) {
    .wizard-progress {
      max-height: 100%;
      max-width: 110px;

      &::after {
        height: 1em;
        left: unset;
        margin-top: -0.5em;
        right: 2px;
        top: 50%;
        transform: rotate(-90deg);
        width: 1em;
      }
    }

    .wizard-form {
      max-width: calc(100% - 110px);
      min-width: calc(100% - 110px);
    }

    &[collapsed] {
      .wizard-progress {
        max-width: 60px;
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }
}

:host(.dark-mode) {
  @include dark-mode;
  @include button-dark-mode;
}
